module.exports = __webpack_public_path__ + "img/Camera&lens1.275ccfab.png";